import { type WrappedInsightTopWorkplacesAttributes } from "@clipboard-health/contract-backend-main";
import { Image, Span, Text } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";

import workplacesIcon from "../../assets/workplaces-wrapped.png";

interface TopWorkplacesContentProps {
  attributes: WrappedInsightTopWorkplacesAttributes;
}

export function TopWorkplacesContent(props: TopWorkplacesContentProps) {
  const { attributes } = props;

  return (
    <Stack flex={1} position="relative" overflow="hidden">
      {/* Text section - top */}
      <Stack spacing={8} paddingX={6} paddingTop={12} sx={{ zIndex: 1 }}>
        <Text variant="body1" color="white">
          Your top {attributes.topFiveWorkplaces.length} workplaces
        </Text>

        <Stack spacing={2}>
          {attributes.topFiveWorkplaces.map((workplace, index) => (
            <Stack key={workplace} direction="row" spacing={5} alignItems="center">
              <Span sx={{ fontSize: "0.75rem", color: "rgba(255,255,255,0.7)" }}>
                no.{index + 1}
              </Span>
              <Text
                variant="h3"
                color="white"
                sx={{
                  fontSize: "1.25rem",
                  maxWidth: "300px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {workplace}
              </Text>
            </Stack>
          ))}
        </Stack>
      </Stack>

      {/* Workplaces image - positioned based on Figma: 434x434 at top 335px, left 16px on 375x812 page */}
      <Box
        position="absolute"
        sx={{
          top: "35%", // 335 / 812
          right: "-20%",
          zIndex: 0,
        }}
      >
        <Image src={workplacesIcon} alt="Workplaces" width="115.7vw" height="auto" />
      </Box>
    </Stack>
  );
}
